import * as Yup from 'yup';

export const SecurityFormValidationSchema = Yup.object().shape({
  exchange: Yup.string().required('errors.required'),
  pre_money: Yup.number(),
  security_type: Yup.string().required('errors.required'),
  valuation_cap: Yup.number(),
});
